export default {"src":"/_next/static/media/location-marker--nearby-accommodation.baddf1c1.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};